import React from 'react';

const UnpublishWarningModal = ({ handleUnpublishCancel, handleUnpublishConfirm }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-md">
        <h3 className="text-xl font-bold mb-4">Warning: Invalid URL</h3>
        <p className="text-gray-600 mb-6">
          The website URL could not be validated. Saving these changes will unpublish your listing.
          Do you want to continue?
        </p>
        <div className="flex gap-4 justify-end">
          <button
            onClick={handleUnpublishCancel}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
          <button
            onClick={handleUnpublishConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Save and Unpublish
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnpublishWarningModal;
